import type { InputHTMLAttributes } from 'react';
import './Input.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Visual error state (red border). Use alongside FormField's `error` prop
   *  to keep label + input in sync. */
  error?: boolean;
}

/**
 * Token-driven `<input>` for forms. Pairs naturally with `FormField` for
 * labels / required marker / error message — `Input` itself owns the visual
 * styling of the field (border, background, padding, focus ring).
 */
export function Input({ error, className = '', ...props }: InputProps) {
  return (
    <input
      className={`ui-input ${error ? 'ui-input--error' : ''} ${className}`.trim()}
      {...props}
    />
  );
}
